//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/SelectBody.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AdjustBoundaryChannel",1,0],[0,"BoundaryChannelExtension",1,0],[1,"ExtendChannel",0,"SelectBodyList",0],[1,"ExtensionValue",0,"Expression",0],[1,"LimitBody",0,"SelectBody",0],[0,"RemoveParameter",1,0],[0,"ReverseDirection",1,0],[0,"RoundTip",1,0],[0,"TipAngle",1,0],[1,"TipAngleValue",0,"Expression",0],[0,"TipEndType",1,0]],[],[]];
SPLM.Tooling.CoolingExtendBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.CoolingExtendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.CoolingExtendBuilder.TipEndTypes = Object.freeze({
    "None" : "None", "Angle" : "Angle", "Round" : "Round"});

export default SPLM;